/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export type ApiStatsAlgorithmsConsultationElAggregateBatchData = ApiResponse & {
  data: {
    /** 배치 처리 성공 여부 */
    isUpdatedSuccess: boolean;
  };
};

export interface ApiStatsAlgorithmsConsultationMonthlyElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2024-07-01"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2024-12-31"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsAlgorithmsConsultationMonthlyElFindData = any;

export interface ApiStatsAlgorithmsConsultationMonthlyElFindHospitalParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2024-07-01"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2024-12-31"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsAlgorithmsConsultationMonthlyElFindHospitalData = any;

export type ApiStatsChatsElAggregateBatchData = ApiResponse & {
  data: {
    /** 배치 처리 성공 여부 */
    isUpdatedSuccess: boolean;
  };
};

export interface ApiStatsChatsMonthlyElFindHospitalParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 시작일
   * @default "2024-07-01"
   */
  startDate?: string;
  /**
   * (required) 월간 통계 조회를 위한 검색 종료일
   * @default "2024-12-31"
   */
  endDate?: string;
  /** skip option */
  skip?: number;
  /**
   * limit option
   * @default 10
   */
  limit?: number;
  /** sort property */
  key?: string;
  /** 오름차순/내림차순 설정 */
  way?: number;
}

export type ApiStatsChatsMonthlyElFindHospitalData = any;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Stats-Algorithms-Consultation
     * @name ApiStatsAlgorithmsConsultationElAggregateBatch
     * @summary 상담 및 마케팅 알고리즘 배치 계산 수행
     * @request POST:/v3/api/stats/algorithms/consultation/el/aggregate/batch
     * @secure
     * @response `200` `ApiStatsAlgorithmsConsultationElAggregateBatchData` 상담 자동화 배치 처리 완료 여부
     */
    apiStatsAlgorithmsConsultationElAggregateBatch: (
      data: {
        /**
         * (optional) 상담 자동화 연산 수행 대상 날짜
         * @default "2024-12-26"
         */
        targetDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiStatsAlgorithmsConsultationElAggregateBatchData, any>({
        path: `/v3/api/stats/algorithms/consultation/el/aggregate/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Stats-Algorithms-Consultation
     * @name ApiStatsAlgorithmsConsultationMonthlyElFind
     * @summary 월간 상담 자동화 기준 상담 자동화 통계 조회
     * @request GET:/v3/api/stats/algorithms/consultation/monthly/el/find/
     * @secure
     * @response `200` `ApiStatsAlgorithmsConsultationMonthlyElFindData` \[\{Stats_MonthlyConsultationAlgorithm\}\] Stats_MonthlyConsultationAlgorithm 컬렉션 객체 배열
     */
    apiStatsAlgorithmsConsultationMonthlyElFind: (
      query: ApiStatsAlgorithmsConsultationMonthlyElFindParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiStatsAlgorithmsConsultationMonthlyElFindData, any>({
        path: `/v3/api/stats/algorithms/consultation/monthly/el/find/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Stats-Algorithms-Consultation
     * @name ApiStatsAlgorithmsConsultationMonthlyElFindHospital
     * @summary 월간 병원 기준 상담 자동화 통계 조회
     * @request GET:/v3/api/stats/algorithms/consultation/monthly/el/find/hospital
     * @secure
     * @response `200` `ApiStatsAlgorithmsConsultationMonthlyElFindHospitalData` \[\{Stats_MonthlyHospitalConsultationAlgorithm\}\] Stats_MonthlyHospitalConsultationAlgorithm 컬렉션 객체 배열
     */
    apiStatsAlgorithmsConsultationMonthlyElFindHospital: (
      query: ApiStatsAlgorithmsConsultationMonthlyElFindHospitalParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiStatsAlgorithmsConsultationMonthlyElFindHospitalData, any>({
        path: `/v3/api/stats/algorithms/consultation/monthly/el/find/hospital`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Stats-Chats
     * @name ApiStatsChatsElAggregateBatch
     * @summary 채팅 응대 및 미응대건 배치 계산 수행
     * @request POST:/v3/api/stats/chats/el/aggregate/batch
     * @secure
     * @response `200` `ApiStatsChatsElAggregateBatchData` 채팅 응대 및 미응대건 배치 계산 완료 여부
     */
    apiStatsChatsElAggregateBatch: (
      data: {
        /**
         * (optional) 채팅 응대 및 미응대건 배치 수행 대상 날짜
         * @default "2024-12-26"
         */
        targetDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiStatsChatsElAggregateBatchData, any>({
        path: `/v3/api/stats/chats/el/aggregate/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Stats-Chats
     * @name ApiStatsChatsMonthlyElFindHospital
     * @summary 월간 병원 기준 채팅 통계 조회
     * @request GET:/v3/api/stats/chats/monthly/el/find/hospital
     * @secure
     * @response `200` `ApiStatsChatsMonthlyElFindHospitalData` \[\{Stats_MonthlyHospitalChat\}\] Stats_MonthlyHospitalChat 컬렉션 객체 배열
     */
    apiStatsChatsMonthlyElFindHospital: (query: ApiStatsChatsMonthlyElFindHospitalParams, params: RequestParams = {}) =>
      this.request<ApiStatsChatsMonthlyElFindHospitalData, any>({
        path: `/v3/api/stats/chats/monthly/el/find/hospital`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
